/**
 * The only place that talks to the Android wrapper about the customer (second) screen. Everything
 * here is a no-op in a browser or on an older wrapper that does not expose the new methods, and
 * nothing here ever throws into the POS.
 */

let lastPayloadJson = null;
let lastOptionsJson = null;

const bridge = () => (typeof window !== 'undefined' ? window.AndroidPOS : undefined);

export const isCustomerDisplayAvailable = () => typeof bridge()?.updateCustomerDisplay === 'function';

export const isCustomerDisplayOptionsAvailable = () => typeof bridge()?.setCustomerDisplayOptions === 'function';

/**
 * Sends one display message. Returns true only when a message was actually handed to the wrapper;
 * an identical consecutive payload is dropped.
 */
export const sendCustomerDisplay = (payload) => {
  try {
    if (!isCustomerDisplayAvailable()) return false;
    const json = JSON.stringify(payload);
    if (json === lastPayloadJson) return false;
    // Called on the interface object itself: Android JS interface methods must not be detached.
    window.AndroidPOS.updateCustomerDisplay(json);
    lastPayloadJson = json;
    return true;
  } catch (e) {
    return false;
  }
};

/**
 * Sends the options object ({logo: {source, url}}). Same guard and de-duplication as above.
 */
export const sendCustomerDisplayOptions = (options) => {
  try {
    if (!isCustomerDisplayOptionsAvailable()) return false;
    const json = JSON.stringify(options);
    if (json === lastOptionsJson) return false;
    window.AndroidPOS.setCustomerDisplayOptions(json);
    lastOptionsJson = json;
    return true;
  } catch (e) {
    return false;
  }
};

/** Forget what was sent (new wrapper session / tests) so the next message goes out again. */
export const resetCustomerDisplayDedupe = () => {
  lastPayloadJson = null;
  lastOptionsJson = null;
};
